export default {
  VerifyModal: {
    title: "تأیید حساب کاربری",
    send: "ارسال برای بررسی",
    step1: {
      reason:
        "این سرویس فقط برای متخصصان پزشکی ایجاد شده است، بنابراین دسترسی به برخی از قابلیت‌ها فقط برای کاربران تأییدشده امکان‌پذیر است. این موضوع به موارد زیر کمک می‌کند:",
      reasons: {
        1: "جلوگیری از دسترسی بیماران و افراد غیرمجاز",
        2: "تضمین جامعه حرفه‌ای برای تبادل دانش و تجربه",
        3: "رعایت اصول اخلاق پزشکی و استانداردهای کار با داده‌ها",
      },
      end: "ما به امنیت و حریم خصوصی شما اهمیت می‌دهیم. تمام اطلاعات فقط برای تأیید وضعیت شما استفاده می‌شوند و پس از پایان فرآیند حذف خواهند شد.",
      status: "وضعیت",
      statuses: {
        doctor: "پزشک",
        student: "دانشجو",
        ordinator: "دستیار",
      },
    },
    step2: {
      agenda:
        "تمام اطلاعات ارائه‌شده محافظت شده‌اند و صرفاً برای تأیید وضعیت شما استفاده خواهند شد.",
      chooseVerifyWay: "روش تأیید را انتخاب کنید",
      ways: {
        1: "مدرک، گواهی یا کارت شناسایی",
        2: "لینک به صفحه تأییدشده در پلتفرم‌های پزشکی (ProDoctorov، DocDoc و غیره)",
        3: "لینک به صفحه شما در وب‌سایت کلینیک",
        4: "آپلود مدرک تحصیلات پزشکی",
        5: "آپلود کارت دانشجویی دانشگاه پزشکی",
      },
      selectFile: "انتخاب فایل",
      sendToCheck: "ارسال برای بررسی",
      pasteLink: "وارد کردن لینک",
      notAllowedFile: "فقط فایل‌های PDF و تصاویر مجاز هستند.",
      noMoreFiles: "حداکثر تعداد فایل‌ها - ",
    },
    step3: {
      title: "مدرک برای بررسی ارسال شد",
      text1_1:
        "ما اطلاعات شما را بررسی خواهیم کرد و پس از آن، اطلاع‌رسانی به ایمیل ",
      text1_2: "",
      text2: "بررسی معمولاً یک روز کاری زمان می‌برد.",
    },
  },
};
